// Ticket 196: the floor the server enforces (backend/password_policy.py). The
// server also blocks common passwords and answers with the reason, which the
// forms show as-is.
export const MIN_PASSWORD = 12;
export const PASSWORD_HINT = `At least ${MIN_PASSWORD} characters`;
